import { render } from "./Services3Section.vue?vue&type=template&id=8e719cde&scoped=true"
import script from "./Services3Section.vue?vue&type=script&lang=js"
export * from "./Services3Section.vue?vue&type=script&lang=js"

import "./Services3Section.vue?vue&type=style&index=0&id=8e719cde&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8e719cde"]])

export default __exports__